
const swiper1 = new Swiper('.featured-collection-slider', {
    direction: 'horizontal',
    slidesPerView: 2.3,
    slidesPerGroup:1,
    centeredSlides: false,
    spaceBetween: 20,
    navigation: {
        nextEl: '.featured-collection-slider__navigation .swiper-button-next',
        prevEl: '.featured-collection-slider__navigation .swiper-button-prev'
    },
    breakpoints: {
      100: {
        slidesPerView: 1.365,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: true,
        loop:true,
      },
      501: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
        loop:false,
      },
      1024: {
        slidesPerView: 2.3,
        spaceBetween: 20,
        slidesPerGroup: 1,
      }
    }
});
